import { useState, useCallback } from 'react';
import { ToastType } from '@/shared/components/feedback/Toast/Toast.types';
import { useToast } from '@/shared/components/feedback/Toast/ToastContext';
import { supplierApi } from '../api/supplierApi';
import { SupplierDetail } from '../types/supplier.types';
import { supplierDetailFromDto } from '../utils/supplierHelpers';
import { loadFilters } from '@/shared/utils/filterStorage';
import { FILTER_STORAGE_KEY, SupplierFilters, filterSuppliers } from '../utils/supplierSelectionHelpers';

interface UseSupplierListReturn {
    suppliers: SupplierDetail[];
    allSuppliers: SupplierDetail[];
    loading: boolean;
    error: boolean;
    setSuppliers: React.Dispatch<React.SetStateAction<SupplierDetail[]>>;
    fetchSuppliers: () => Promise<void>;
}

export const useSupplierList = (): UseSupplierListReturn => {
    const { showToast } = useToast();
    const [suppliers, setSuppliers] = useState<SupplierDetail[]>([]);
    const [allSuppliers, setAllSuppliers] = useState<SupplierDetail[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const fetchSuppliers = useCallback(async () => {
        try {
            setLoading(true);
            setError(false);
            const response = await supplierApi.getSupplierList();
            const detailedSuppliers = response.suppliers.map(supplierDetailFromDto);
            const savedFilters = loadFilters<SupplierFilters>(FILTER_STORAGE_KEY);
            if (savedFilters) {
                setSuppliers(filterSuppliers(detailedSuppliers, savedFilters));
            } else {
                setSuppliers(detailedSuppliers);
            }
            setAllSuppliers(detailedSuppliers);
        } catch {
            setError(true);
            showToast('협력사 목록을 불러오는데 실패했습니다.', { type: ToastType.ERROR });
        } finally {
            setLoading(false);
        }
    }, [showToast]);

    return { suppliers, allSuppliers, loading, error, setSuppliers, fetchSuppliers };
};
